import { BotMessageSquare, LayoutDashboard, Leaf, MessageCircle, Mic, Video, WholeWord } from 'lucide-react'

import user1 from '../assets/caique.jpg'
import user2 from '../assets/mariana.png'
import { MessageBubble } from '../components/MessageBubble'

export const navItems = [
    { label: 'Funcionalidades', href: '#' },
    { label: 'Workflow', href: '#' },
    { label: 'Preço', href: '#' },
    { label: 'O que estão falando', href: '#' }
]

export const testimonials = [
    {
        user: 'Caíque Coelho',
        image: user1,
        text: 'Com o LinguaLearn, eu consigo salvar e revisar todas as palavras que eu preciso aprender, isso tornou o processo de praticar a fala e pronúncia de cada palavra muito mais fácil'
    },
    {
        user: 'Mariana Macedo',
        image: user2,
        text: "Depois que comecei a usar o LinguaLearn, minha pronúncia se tornou muito melhor. Eu aprendi novas palavras e comecei a falar com mais fluência."
    },
    // {
    //     user: 'David Johnson',
    //     company: 'Quantum Innovations',
    //     image: user3,
    //     text: 'Working with this company was a pleasure. Their attention to detail and commitment to excellence are commendable. I would highly recommend them to anyone looking for top-notch service.'
    // },
    // {
    //     user: 'Ronee Brown',
    //     company: 'Fusion Dynamics',
    //     image: user4,
    //     text: 'Working with the team at XYZ Company was a game-changer for our project. Their attention to detail and innovative solutions helped us achieve our goals faster than we thought possible. We are grateful for their expertise and professionalism!'
    // },
    // {
    //     user: 'Michael Wilson',
    //     company: 'Visionary Creations',
    //     image: user5,
    //     text: 'I am amazed by the level of professionalism and dedication shown by the team. They were able to exceed our expectations and deliver outstanding results.'
    // },
    // {
    //     user: 'Emily Davis',
    //     company: 'Synergy Systems',
    //     image: user6,
    //     text: 'The team went above and beyond to ensure our project was a success. Their expertise and dedication are unmatched. I look forward to working with them again in the future.'
    // }
]

export const features = [
    {
        icon: <Mic />,
        text: 'Speaking',
        description:
            'Utilize seu microfone para falar as frases sugeridas e receba uma nota para a sua pronúncia.'
    },
    {
        icon: <MessageCircle />,
        text: 'AI teacher',
        description:
            'Pratique a fala e a pronúncia com a nossa AI teacher disponivel 24 horas!'
    },
    {
        icon: <WholeWord />,
        text: 'Vocabulary',
        description:
            'Busque por palavras que você queira aprender, salve-as e acompanhe o seu progresso.'
    },
    {
        icon: <Video />,
        text: 'Videos',
        description:
            'Aprenda com os melhores videos de speaking e listening'
    },
    {
        icon: <Leaf />,
        text: 'Themes',
        description: 'Siga as trilhas de conhecimento recomendadas e aprenda novas palavras'
    },
    {
        icon: <LayoutDashboard />,
        text: 'Dashboard',
        description:
            'Acompanhe o seu progresso com um dashboard personalizado e cheio de estatísticas sobre o seu aprendizado'
    }
]

export const speakingFeature = [
    {
        title: 'Pratique a fala',
        description: 'Use seu microfone para falar as frases sugeridas e receba uma nota para a sua pronúncia.'
    },
    {
        title: 'Feedback em tempo real',
        description: 'Veja quais palavras você acertou e quais você precisa melhorar'
    },
    {
        title: 'Escuta e aprenda',
        description: 'Escute as pronúncias das frases e das palavras'
    }
]

export const themesFeature = [
    {
        title: 'Aprenda novas palavras',
        description: 'Selecione um tema específico e aprenda novas palavras relacionadas ao tema.'
    },
    {
        title: 'Acompanhe o seu progresso',
        description: 'Pratique as palavras de cada tema e acompanhe o seu progresso para cada tema'
    },
]

export const videosFeature = [
    {
        title: 'Encontre videos específicos',
        description: 'Consolide o seu conhecimento com videos de speaking, listening, vocabulary and grammar'
    },
    {
        title: 'Salve os vídeos',
        description: 'Você pode salvar os videos que você gostou ou que deseja assistir mais tarde'
    },
]

export const vocabularyFeature = [
    {
        title: 'Aprenda novas palavras',
        description: 'Aprenda a definição e pronúncia de novas palavras'
    },
    {
        title: 'Veja exemplos de uso',
        description: 'Veja exemplos de uso das palavras em frases e pratique a fala'
    },
    {
        title: 'Salve as palavras',
        description: 'Salve as palavras que deseja aprender e acompanhe o seu progresso'
    },
]

export const wordFeature = [
    {
        title: 'Escute as pronúncias',
        description: 'Escute a pronúncia de cada palavra separadamente'
    },
    {
        title: 'Aprenda a definição',
        description: 'Entenda a definição de cada palavra em cada contexto'
    },
]

export const aiChatFeature = [
    {
        title: 'AI teacher',
        description: 'Com a nossa AI você receberá feedbacks em tempo real sobre sua escrita e pronúncia'
    },
    {
        title: 'AI talk',
        description: 'Converse sobre qualquer assunto com a nossa AI'
    },
    {
        title: 'Fale ou digite',
        description: 'Escolha entre falar ou digitar com o nosso live chat'
    },
    {
        title: 'Escute ou leia',
        description: 'Pratique a sua escuta e leitura conversando com a nossa AI'
    },
]

export const pricingOptions = [
    {
        title: 'Diario',
        price: 'R$1',
        features: ['Pagamento Diário', 'Testes Ilimitados', 'Vaga Match']
    },
    {
        title: 'Mensal',
        price: 'R$30',
        features: ['Pagamento Mensal', 'Testes Ilimitados', 'Vaga Match']
    },
    {
        title: 'Semestral',
        price: 'R$150',
        features: ['Pagamento Semestral', 'Testes Ilimitados', 'Vaga Match']
    },
    {
        title: 'Anual',
        price: 'R$240',
        features: ['Pagamento Anual', 'Testes Ilimitados', 'Vaga Match']
    }
]

export const resourcesLinks = [
    { href: '#', text: 'Getting Started' },
    { href: '#', text: 'Documentation' },
    { href: '#', text: 'Tutorials' },
    { href: '#', text: 'API Reference' },
    { href: '#', text: 'Community Forums' }
]

export const platformLinks = [
    { href: '#', text: 'Features' },
    { href: '#', text: 'Supported Devices' },
    { href: '#', text: 'System Requirements' },
    { href: '#', text: 'Downloads' },
    { href: '#', text: 'Release Notes' }
]

export const communityLinks = [
    { href: '#', text: 'Events' },
    { href: '#', text: 'Meetups' },
    { href: '#', text: 'Conferences' },
    { href: '#', text: 'Hackathons' },
    { href: '#', text: 'Jobs' }
]
